// ---------------------------------------------------------------------------
// Who this product says it is.
//
// One place, because the name was in twenty files and a rename meant finding
// every one of them — the sort of change that is always 90% done. Anything
// user-visible that names the product reads from here.
//
// The legal entity is deliberately separate from the product name: policies,
// invoices and a refund notice have to name the company that is actually party
// to the contract, and that is not the same string as the brand on the header.
// ---------------------------------------------------------------------------

export const BRAND = {
  name: 'SellerList AI',
  // Used where the name has already been said and repeating it reads badly —
  // a page title next to the logo, for instance.
  shortName: 'SellerList',
  // Deliberately does NOT say "every marketplace". Meesho is the one a seller
  // can get a file for today — ENABLED_MARKETPLACES has exactly one entry and
  // the export engine refuses the rest — so claiming more would be an advert
  // for something the product declines to do.
  //
  // There is no `tagline` here any more. It sat under the wordmark in the app
  // header, the sign-in panel and both footers, which meant the name was never
  // allowed to stand on its own. The name is the brand; a sentence stapled to
  // it in four places is decoration.
  description:
    'Fill a product in once and get a Meesho-ready upload file — with the title, '
    + 'description and images prepared for you. Flipkart, Amazon and Myntra are '
    + 'coming soon.',

  // The company behind it. Policies must name this, not the brand.
  legalEntity: 'Spaweval Technologies',
  country: 'India',

  // Contact. One address per purpose, so a seller with a billing question is
  // not writing to the same inbox as a bug report.
  email: {
    // Machine-sent, no conversation expected: verification codes and the
    // like. A reply still reaches support rather than vanishing, because a
    // seller who replies to a code deserves an answer, not a void.
    noReply: 'no-reply@sellerlist.in',
    // General enquiries — the address a stranger writes to when they do not
    // yet know which team they need.
    info: 'info@sellerlist.in',
    // Anything an ADMINISTRATOR decides about somebody's account: a vendor
    // approved or refused, stores linked or unlinked. Deliberately not
    // support@ — these are decisions, not conversations, and a reply to one
    // should reach the people who make them.
    admin: 'admin@sellerlist.in',
    support: 'support@sellerlist.in',
    privacy: 'privacy@sellerlist.in',
    billing: 'billing@sellerlist.in'
  },

  site: 'https://sellerlist.in',

  // What the support page promises. Stated once so the page, the ticket form
  // and the admin's own view of their duty cannot disagree about it.
  supportHours: 'Monday to Saturday, 10am – 7pm IST',
  firstReplyTarget: 'within one working day'
};

/** "© 2026 SellerList AI. All rights reserved." */
export const copyright = () => `© ${new Date().getFullYear()} ${BRAND.name}. All rights reserved.`;

export default BRAND;
